import { useNavigate } from 'react-router-dom'

import useGetAuthSessionQuery from '~/features/auth/hooks/useGetAuthSessionQuery'
import useSignOut from '~/features/auth/hooks/useSignOut'
import useIsPartner from '~/features/partners/hooks/useIsPartner'
import { isLibbyDomain } from '~/features/partners/utils'
import { EClientPath, EMarketingClientPath } from '~/models/api'
import { store } from '~/store'

const useErrorRedirect = () => {
  const navigate = useNavigate()
  const [errorFallbackRedirectCount, resetStore, setUIElements] = store(
    (state) => [
      state.UIElements.errorFallbackRedirectCount,
      state.resetStore,
      state.setUIElements,
    ],
  )
  const { data: authSession } = useGetAuthSessionQuery()
  const isPartner = useIsPartner() || !isLibbyDomain()
  const isLoggedIn = !!authSession?.email
  const { signOut } = useSignOut()

  const redirectToSafety = async () => {
    switch (errorFallbackRedirectCount) {
      case 0:
        setUIElements({ errorFallbackRedirectCount: 1 })
        if (isLoggedIn) {
          navigate(EClientPath.overview)
        } else {
          navigate(
            isPartner ? EClientPath.partnerAuth : EMarketingClientPath.home,
          )
        }
        break
      case 1:
        setUIElements({ errorFallbackRedirectCount: 2 })
        await signOut()
        resetStore()
        break
      default:
        // Should never reach here... but if it does, reset the count and navigate to home
        setUIElements({ errorFallbackRedirectCount: 0 })
        navigate(
          isPartner ? EClientPath.partnerAuth : EMarketingClientPath.home,
        )
        break
    }
  }
  return { redirectToSafety }
}

export default useErrorRedirect
